import { css } from '@emotion/css'
import { fontSize } from '../../styles'
import { getSkeletonColors } from '../../themes'

const styles = {
  wrapper: css({
    display: 'inline-flex',
    alignItems: 'center',
  }),

  text: css({
    display: 'block',
  }),
}

export default styles

export const wrapperSize = size => {
  switch (size) {
    case 'extraSmall':
      return css({
        height: fontSize.extraSmall * 1.2,
      })

    case 'small':
      return css({
        height: fontSize.small * 1.2,
      })

    case 'medium':
      return css({
        height: fontSize.medium * 1.2,
      })

    case 'large':
      return css({
        height: fontSize.large * 1.2,
      })

    default:
      return css({
        height: fontSize.default * 1.2,
      })
  }
}

export const textTheme = theme =>
  css({
    backgroundColor: getSkeletonColors(theme),
  })

export const textSize = (size, width) => {
  switch (size) {
    case 'extraSmall':
      return css({
        width,
        height: fontSize.extraSmall,
      })

    case 'small':
      return css({
        width,
        height: fontSize.small,
      })

    case 'medium':
      return css({
        width,
        height: fontSize.medium,
      })

    case 'large':
      return css({
        width,
        height: fontSize.large,
      })

    default:
      return css({
        width,
        height: fontSize.default,
      })
  }
}
